// Clock-in window (same rule as the server, services/roster/clock_window.py): clock-in opens CLOCK_IN_OPENS_MIN before the
// scheduled start and closes when the shift ends. The server enforces it (and may use an organisation-specific window);
// this only lets the screen disable the button and say when clock-in opens.
export const CLOCK_IN_OPENS_MIN = 120;

const at = (date, time) => {
  if (!date || !/^\d{1,2}:\d{2}/.test(time || '')) return null;
  const d = new Date(`${date}T${time.length === 4 ? `0${time}` : time.slice(0, 5)}`);
  return Number.isNaN(d.getTime()) ? null : d;
};

/** { state: 'before' | 'open' | 'ended' | 'unknown', opensAt, endsAt } for `now` (ms or Date). */
export function clockInWindow(shift, now = Date.now(), opensMin = CLOCK_IN_OPENS_MIN) {
  const start = at(shift?.date, shift?.start_time);
  let end = at(shift?.end_date || shift?.date, shift?.end_time);
  if (!start || !end) return { state: 'unknown', opensAt: null, endsAt: null };
  if (!shift?.end_date && end <= start) end = new Date(end.getTime() + 86400000);   // overnight shift ends the next day
  const opensAt = new Date(start.getTime() - opensMin * 60000);
  const t = typeof now === 'number' ? now : now.getTime();
  const state = t < opensAt.getTime() ? 'before' : t >= end.getTime() ? 'ended' : 'open';
  return { state, opensAt, endsAt: end };
}

const hhmm = (d) => d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
const day = (d) => d.toLocaleDateString([], { weekday: 'short', day: 'numeric', month: 'short' });

/** Text for a closed window, or '' when clock-in is open / unknown. */
export function clockInClosedText(w) {
  if (w.state === 'before') return `Clock-in opens at ${hhmm(w.opensAt)} on ${day(w.opensAt)} (2 hours before the shift starts)`;
  if (w.state === 'ended') return `This shift ended at ${hhmm(w.endsAt)} — clock-in is closed`;
  return '';
}
